import { createContext } from "react";

export const PageContext = createContext({
  tabPresent: false,
  setTabPresence: () => {}
});

export default PageContext.Provider;
